var path = 'app/scripts/modules/amazon/src/serverGroup/configure/wizard/capacity/targetHealthyPercentageSelector.component.html';
var html = "<div class=\"form-group form-inline\" style=\"margin-top: 20px\">\n  <div class=\"col-md-12\">\n    Consider deployment successful when\n    <input type=\"number\"\n           min=\"0\"\n           max=\"100\"\n           ng-model=\"$ctrl.command.targetHealthyDeployPercentage\"\n           class=\"form-control input-sm inline-number\"\n        />\n    percent of instances are healthy.\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/configure/wizard/capacity/targetHealthyPercentageSelector.component.html
// module id = 1196
// module chunks = 0